module.exports = __webpack_public_path__ + "static/media/fixed_voice_attach_file.1d9b3a62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_attach_file.svg
// module id = 3214
// module chunks = 0